<ng-container *transloco="let t">
  <app-page-template>
    <div class="container container-no-padding-sm">
      <app-page-header-public [currentItem]="currentEventItem"/>
      <app-info-section-public [currentItem]="currentEventItem" [languages]="languages"
                               [currentItemType]="CurrentItemType.EVENT">
        <ng-container slot="title-slot">
          <h1 class="info-area__title flex-grow-1 trim-text-second-line pe-2">
            <app-language-output [hrLabel]="currentEventItem?.name" [enLabel]="currentEventItem?.nameEng"
                                 [itLabel]="currentEventItem?.nameIta" [siLabel]="currentEventItem?.nameSlo"
                                 [defaultLanguage]="currentEventItem?.defaultLanguage" [languages]="languages"/>
          </h1>
        </ng-container>
      </app-info-section-public>
    </div>
    <div class="container nav-bar-padding">
      <app-nav-tabs>
        <app-nav-tab [title]="t('app.common.races')" [itemId]="1">
          <ng-template>
            <div class="pt-62-32 pb-300-228" [ngClass]="{'pb-300-228': !isPreviewComponent}">
              @for (item of currentEventItem?.racesList;track item.id;let isLast=$last) {
                <app-race-grid-item [logoPath]="currentEventItem!.imageMedium" [currencyLabel]="eventCurrency"
                                    [raceCommercialItems]="raceCommericalItemsMap.get(item)" [race]="item"
                                    [eventItem]="currentEventItem"
                                    [isLast]="isLast" [languages]="languages"/>
              }
            </div>
          </ng-template>
        </app-nav-tab>
        <app-nav-tab [title]="t('events.details.event.info')" [itemId]="2">
          <ng-template>
            <app-event-info-tab [currentEventItem]="currentEventItem" [languages]="languages"/>
          </ng-template>
        </app-nav-tab>
        <app-nav-tab [title]="t('events.details.contacts')" [itemId]="3">
          <ng-template>
            <app-contacts-tab [currentItem]="currentEventItem" [languages]="languages"/>
          </ng-template>
        </app-nav-tab>
        <app-nav-tab [title]="t('events.details.results')" [itemId]="4">
          <ng-template>
            <div class="pt-62-32 pb-300-228">
              <app-results-table [results]="results" [languages]="languages" [showRaceNameInTable]="true"
                                 [categories]="categories" [genders]="genders"
                                 [filteringEnabled]="true" [showEmptyState]="true"
                                 [currentEventItem]="currentEventItem" [showBorderBottom]="false"/>
            </div>
          </ng-template>
        </app-nav-tab>
        <div class="d-none d-xxl-flex">
          <app-share-favourite-cta [eventItem]="currentEventItem" [isPreviewComponent]="isPreviewComponent"/>
        </div>
      </app-nav-tabs>
    </div>
    @if (!isPreviewComponent) {
      <app-footer/>
    }
  </app-page-template>
</ng-container>
